module.exports = __webpack_public_path__ + "Cross-Platform.svg?5e5f2ec92aa217fb42a9450637c9e8bd";